export const getTiles = (state) => {
  const caseIds = Object.keys(state.data.cases);
  if (state.data) {
    const tiles = caseIds.map((caseId) => {
      const caseItem = state.data.cases[caseId];
      if (!Array.isArray(caseItem)) {
        debugger;
      }
      const newTile = caseItem.find(section => section && section.type === 'tile');
      newTile.href = `/works/${caseId}`;
      return newTile;
    });
    return tiles;
  }
};

export const getCase = state =>
  (state.data.cases ? state.data.cases[state.location.payload.caseItem] : []);

export const getNextPreview = (state) => {
  let nextCaseId;
  const caseIds = Object.keys(state.data.cases);

  const caseId = caseIds.findIndex(caseItem => caseItem === state.location.payload.caseItem);

  if (caseId + 1 < caseIds.length) {
    nextCaseId = caseIds[caseId + 1];
  } else {
    nextCaseId = caseIds[0];
  }

  const nextCasePreview = {
    ...state.data.cases[nextCaseId].find(section => section && section.type === 'preview'),
    href: `/works/${nextCaseId}`,
  };
  return nextCasePreview;
};

const getPreviewFromCase = (caseItem, caseId) => {
  const { title: heroTitle, video, colors } = caseItem.find(section => section && section.type === 'hero');
  return {
    heroTitle,
    video,
    colors,
    id: caseId,
  };
};

const getNextCaseKey = (caseKeys, caseKeyIndex) => {
  if (caseKeyIndex + 1 < caseKeys.length) {
    return caseKeys[caseKeyIndex + 1];
  }
  return caseKeys[0];
};

export const getPreviews = (state) => {
  const caseKeys = Object.keys(state.data.cases);

  const caseKeyIndex = caseKeys.findIndex(caseItem => caseItem === state.location.payload.caseItem);
  const nextCaseKey = getNextCaseKey(caseKeys, caseKeyIndex);

  const currentPreview = {
    ...getPreviewFromCase(
      state.data.cases[state.location.payload.caseItem],
      state.location.payload.caseItem,
    ),
    href: '',
    mode: 'hero',
  };
  const nextPreview = {
    ...getPreviewFromCase(state.data.cases[nextCaseKey], nextCaseKey),
    href: `/works/${nextCaseKey}`,
    mode: 'footer',
  };

  return [currentPreview, nextPreview];
};

export const getLogoColor = state => state.scrollPosition.color;
export const getScrollPosition = state => state.scrollPosition.position;

export const getStaticMeta = (state) => {
  const result = state.data[state.page.toLowerCase()].find(section => section && section.type === 'meta');

  return result;
};

export const getCaseLength = state =>
  (getCase(state) ? getCase(state).length : null);

export const isSliderDesktopActive = (state, props) =>
  state.activeSection === `sliderDesktop-${props.code}`;

export const getMenuVisibility = state =>
  state.pageReady && (state.menuOpen || state.mobileStartPage);

export const getMenuData = state =>
  state.data.menu && state.data.menu.find(item => item.type === 'menu');
export const getMenuLogoColors = state =>
  state.data.menu && state.data.menu.find(item => item.type === 'menu').colors;



// WEBPACK FOOTER //
// ./src/selectors/index.js